import { render, staticRenderFns } from "./TaskEditPage.vue?vue&type=template&id=79923697&scoped=true&"
import script from "./TaskEditPage.vue?vue&type=script&lang=js&"
export * from "./TaskEditPage.vue?vue&type=script&lang=js&"
import style0 from "./TaskEditPage.vue?vue&type=style&index=0&id=79923697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79923697",
  null
  
)

export default component.exports